import { useQuery } from "@tanstack/react-query";

/**
 * Generic React Query wrapper.
 *
 * @param {string | Array} key - Unique cache key or array of keys.
 * @param {Function} fetchFn - Async function to fetch the data.
 * @param {Object} options - Additional React Query options (optional).
 */
export function useAppQuery(key, fetchFn, options) {
  return useQuery({
    queryKey: key,
    queryFn: fetchFn,
    staleTime: Infinity,
    ...options,
  });
}
